import React from "react";

const Us = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className=" col-12 my-2">
            <h3>Historia: </h3>
            <p>
              Empresa inovadora fundada en 2016 enfocada a la comercialización
              de materiales y EPP, con el firme deseo de continuamente cubrir
              sus necesidades de abasteciamiento en el tiempo oportuno con la
              mejora calidad e inigualable servicicio.
            </p>
          </div>
          <div className=" col-12 my-2">
            <h3>Misión</h3>
            <p>
              Satisfacer todas las necesidades de abastecimiento industrial de
              manera inmediata, contribuyendo al desarrollo y crecimiento de
              nuestros clientes.
            </p>
          </div>
          <div className=" col-12 my-2">
            <h3>Visión</h3>
            <p>
              Empresa eficaz reconocida dentro del sector industrial por costos,
              calidad y servicios con prescencia en toda la Republica Mexicana.
            </p>
          </div>
          <div className=" col-12 my-2">
            <h3>Valores</h3>
            <p>Servicio, Calidad y Precio</p>
          </div>
          <div className=" col-12 my-2">
            <h3>Licitaciones</h3>
            <p> Gobierno Federal, Defensa Nacional, Ejercito Mexicano</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Us;
